<div class="container-fluid filter-box">
  <div class="col-12 d-flex mb-4 filter-content">
    <input
      type="text"
      class="form-control filter-input text-start"
      (keyup)="filterResults()"
      [(ngModel)]="searchTerm"
      placeholder="{{ 'companies.search' | translate }}"
    />
  </div>
</div>
<div class="container-fluid filter-box">
  <div class="col-12 d-flex mb-4 filter-content">
    <button
      class="btn btn-primary ms-2"
      [class.active]="activeTab === 'proposals'"
      (click)="dataList('proposals')"
    >
      {{ 'proposals_and_orders.proposals' | translate }} {{'(' + server + ')'}}
    </button>
    <button
      class="btn btn-primary ms-2"
      [class.active]="activeTab === 'orders'"
      (click)="dataList('orders')"
    >
      {{ 'proposals_and_orders.orders' | translate }} {{'(' + server + ')'}}
    </button>
  </div>
</div>
<div class="mat-elevation-z2 orders-tables">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    class="fixed-table"
    (matSortChange)="sortData($event)"
  >
    <ng-container matColumnDef="magentoCartId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.magento_cart_id' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-cart-id">
        <span *ngIf="element.magentoCartId">{{element.magentoCartId}}</span>
        <span *ngIf="!element.magentoCartId">{{'not available'}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="magentoOrderId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.magento_order_id' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-order-id">
        <span *ngIf="element.magentoOrderId">{{element.magentoOrderId}}</span>
        <span *ngIf="!element.magentoOrderId">{{'not available'}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="userId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.user_id' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-userId">
        <a [routerLink]="'/users/' + element.userId">{{element.userId}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="patient.companyId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.company_id' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-companyId">
        <a *ngIf="element.patient" [routerLink]="'/companies/' + element.patient.companyId"
          >{{element.patient.companyId}}</a
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.status' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-status">{{element.status}}</td>
    </ng-container>
    <ng-container matColumnDef="products">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.products_amount' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-amount">{{element.products.length}}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'proposals_and_orders.date' | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="td-date">{{ element.createdAt }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="isLoading" class="table-loader">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
      class="loader-status"
      [diameter]="40"
    >
    </mat-progress-spinner>
  </div>
  <mat-paginator [pageSizeOptions]="[20, 40]" showFirstLastButtons></mat-paginator>
</div>
